import { getData } from "./getData";
import { Post } from "@aleksundshantu/schirdewan-standard-types/client";

export async function getVideoData({
  videoId,
  fields,
  locale,
  defaultLocale,
}: {
  videoId: string;
  fields?: string;
  locale?: string;
  defaultLocale?: string;
}): Promise<Post<"videos"> | null> {
  const url = "/videos/" + videoId + (fields ? `?_fields=${fields}` : "");
  const response = await getData(url, locale, defaultLocale);
  if (!response) {
    throw new Error(`Video with ID ${videoId} not found`);
  }
  return response as Post<"videos">;
}
